import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { KeepItemTrackingEvent, TrackingEventName, TrackingEventCategory } from "./tracking";
import { PROJECT, TrackingPage } from "./tracking";

interface KeepItemFunction {
  (): void;
}

interface UseTrackKeepItemFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly checkoutId: string | undefined;
  readonly checkoutItemId: string;
  readonly tradename: Tradename;
}
interface UseTrackKeepItemFunction {
  (agrs: UseTrackKeepItemFunctionArgs): KeepItemFunction;
}

const useTrackKeepItem: UseTrackKeepItemFunction = ({
  page,
  country,
  tradename,
  segment,
  checkoutId,
  checkoutItemId,
}) => {
  const emitUserEvent = useEmitUserEvent<KeepItemTrackingEvent>();

  const keepItem: KeepItemFunction = useCallback(() => {
    if (!checkoutId) {
      return;
    }

    const keepItemTrackingEvent: KeepItemTrackingEvent = {
      event: TrackingEventName.KEEP_ITEM,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_${page}`,
      store: country,
      tradename,
      segment,
      checkoutId,
      checkoutItemId,
    };

    emitUserEvent(keepItemTrackingEvent);
  }, [checkoutId, checkoutItemId, country, tradename, emitUserEvent, page, segment]);

  return keepItem;
};

export { useTrackKeepItem };
